import {API} from "../services/api.service";
export class Menu {
  public title : string;
  public description : string;
  public id : string|number; // can be either name or id
  public url : string;
  public image : string;
  public layout;
  public imageBlurred : string;
  public imageBlurredUrl : string;
  constructor(payload : MenuPayload){
    this.title = payload.title;
    this.description = payload.description;
    this.id = payload.id;
    this.url = payload.url;

    if (payload.image) {
      this.layout = "card";
      this.image = payload.image.indexOf("http") !== 0 ? `${API.BASE_HOST}${payload.image}` : payload.image;
      this.imageBlurred = payload.image.indexOf("http") !== 0 ? `${API.BASE_HOST}${payload.image}` : payload.image;
      this.image = this.imageBlurred;
      this.imageBlurredUrl = `url(${this.imageBlurred})`;
    } else {
      this.layout = "list-item";
    }

  }
}

export interface MenuPayload extends JSON {
  title : string;
  description : string;
  id : string|number;
  url : string;
  image : string;
}



// WEBPACK FOOTER //
// ./src/app/classes/menu.ts